'use client';

import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function HomePage() {
  const { data: session, status } = useSession();
  const router = useRouter();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      if (status === 'authenticated' && session?.user) {
        try {
          // Check if user has completed onboarding
          const response = await fetch('/api/user/onboarding-status');
          const data = await response.json();
          
          if (data.success && (data.onboardingComplete || data.onboardingSkipped)) {
            // User has completed or skipped onboarding, redirect to home
            router.push('/home');
          } else {
            // First-time user, redirect to onboarding
            router.push('/onboarding');
          }
        } catch (error) {
          console.error('Error checking onboarding status:', error);
          // On error, default to onboarding for safety
          router.push('/onboarding');
        }
      } else if (status === 'unauthenticated') {
        // User is not authenticated, redirect to sign-in
        router.push('/auth/signin');
      }
      setChecking(false);
    };

    if (status !== 'loading') {
      checkOnboardingStatus();
    }
  }, [status, session, router]);

  // Show loading state while checking authentication and onboarding
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}
